// Clearance uses the full fish body footprint, including tail motion.
export function fishPointClear(fish, x, z, neighbors = []) {
  return neighbors.every(other => other === fish || other.active === false
    || Math.hypot(x - other.x, z - other.z) >= fish.clearanceRadius + other.clearanceRadius);
}

export function fishAvoidanceDirection(fish, dx, dz, neighbors = []) {
  const length = Math.hypot(dx, dz) || 1;
  let x = dx / length, z = dz / length;
  for (const other of neighbors) {
    if (other === fish || other.active === false) continue;
    const ox = fish.x - other.x, oz = fish.z - other.z, distance = Math.hypot(ox, oz);
    const range = (fish.clearanceRadius + other.clearanceRadius) * 1.8;
    if (distance >= range || distance < .0001) continue;
    const strength = (1 - distance / range) * 2.4;
    x += ox / distance * strength; z += oz / distance * strength;
  }
  const magnitude = Math.hypot(x, z) || 1;
  return { x: x / magnitude, z: z / magnitude };
}

// A repulsion vector alone can point into the shore, or cancel the target
// vector at a stable equilibrium. Try nearby headings instead of parking.
export function fishSafeDirection(fish, direction, step, neighbors, safePoint) {
  const clear = (x, z) => safePoint(x, z) && fishPointClear(fish, x, z, neighbors);
  const heading = Math.hypot(direction.x, direction.z) > .001
    ? Math.atan2(direction.z, direction.x) : fish.heading;
  const side = fish.seed & 1 ? 1 : -1;
  const offsets = [0, side * Math.PI / 6, -side * Math.PI / 6,
    side * Math.PI / 3, -side * Math.PI / 3, side * Math.PI / 2, -side * Math.PI / 2,
    side * Math.PI * 2 / 3, -side * Math.PI * 2 / 3, Math.PI];
  for (const offset of offsets) {
    const x = Math.cos(heading + offset), z = Math.sin(heading + offset);
    if (clear(fish.x + x * step, fish.z + z * step)) return { x, z };
  }
  return null;
}

// Measure displacement, rather than total path length: tiny back-and-forth
// movements must not count as successful exploration.
export function fishNeedsNewTarget(fish, seconds) {
  if (fish.progressX == null) { fish.progressX = fish.x; fish.progressZ = fish.z; fish.progressSeconds = 0; }
  fish.progressSeconds += seconds;
  if (fish.progressSeconds < 1.5) return false;
  const stuck = Math.hypot(fish.x - fish.progressX, fish.z - fish.progressZ) < (fish.cruiseSpeed ?? fish.speed) * .4;
  fish.progressX = fish.x; fish.progressZ = fish.z; fish.progressSeconds = 0;
  return stuck;
}
